var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreIcon = function SvgMoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33341 0.333252C3.25389 0.333252 4.00008 1.07944 4.00008 1.99992C4.00008 2.92039 3.25389 3.66659 2.33341 3.66659C1.41294 3.66659 0.666748 2.92039 0.666748 1.99992C0.666748 1.07944 1.41294 0.333252 2.33341 0.333252ZM15.6667 0.333252C16.5872 0.333252 17.3334 1.07944 17.3334 1.99992C17.3334 2.92039 16.5872 3.66659 15.6667 3.66659C14.7463 3.66659 14.0001 2.92039 14.0001 1.99992C14.0001 1.07944 14.7463 0.333252 15.6667 0.333252ZM9.00008 0.333252C9.92056 0.333252 10.6667 1.07944 10.6667 1.99992C10.6667 2.92039 9.92056 3.66659 9.00008 3.66659C8.07961 3.66659 7.33342 2.92039 7.33342 1.99992C7.33342 1.07944 8.07961 0.333252 9.00008 0.333252Z",
    fill: "#767676"
  })));
};
export { SvgMoreIcon as ReactComponent };
export default __webpack_public_path__ + "assets/f4ef0693.svg";